<micro-lookup domain="auth" obj="departments" url="/departments" [key]="departmentId" [link]="link"></micro-lookup>
